import React, { Fragment } from 'react';
import { Form, Select } from 'antd';

// todo переделать, лишние вычисления
//Список годов для итерации
function createYearList() {
  const currentYear = Number(new Date().getFullYear());
  var yearList = [];
  for (var i = 1977; i <= currentYear; i++) {
    yearList.push(i);
  }
  return yearList.reverse();
}

const ProductionYear = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Год выпуска:</span>
      <Form.Item>
        {getFieldDecorator('productionYear', {
          rules: [{
            required: true,
            message: "Поле, обязательно для заполнения"
          }]
        })(
          <Select
            placeholder="Год"
            className="smallInput"
            disabled={disabled}
            getPopupContainer={trigger => trigger.parentNode}
          >
            {createYearList().map((year, index) => (
              <Select.Option value={year} key={index}>
                {year}
              </Select.Option>
            ))}
          </Select>
        )}
      </Form.Item>
    </Fragment>
  );
};

export default ProductionYear;
